import { CalendarClock } from "lucide-react";
import { CONFIG } from "@/config";

export const Logo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="36" height="36" rx="8" fill="#141612" />
    <path d="M9 10L16 26L20 18L14 10H9Z" fill="#B6F23C" />
    <path d="M27 10L20 26L16 18L22 10H27Z" fill="#D9B25F" />
    <path d="M18 10L22 18H14L18 10Z" fill="#F4F5F2" />
  </svg>
);

export const Header = ({ badge }) => (
  <header className="relative z-10 flex flex-wrap items-center justify-between gap-y-3 py-5 sm:py-7" data-testid="site-header">
    <a href="/" className="flex items-center group" data-testid="header-logo">
      <img
        src="/logo.png"
        alt="Virality School"
        className="h-9 sm:h-11 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
      />
    </a>
    <span className="eyebrow !text-[#D9B25F] !normal-case !tracking-normal !text-xs sm:!text-sm w-full sm:w-auto justify-center sm:justify-start" data-testid="header-expiry-notice">
      <CalendarClock className="h-3.5 w-3.5 shrink-0" />
      {CONFIG.gate.expiryText}
    </span>
  </header>
);
